import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, AfterViewInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { parseJSON } from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'deposit-apco.component',
  templateUrl: '../sharedTemplates/deposit-apco.component.html',
})
export class DepositApcoComponent implements OnInit, AfterViewInit {
  DepositTypeId = 71;

  MinValue = 0;
  MaxValue = 0;

  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  firststep = true;
  insicstatus = '2';
  typeid = 0;
  title = 'Apco Pay';
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.typeid = params['typeid'];
      if (this.typeid == 1) {
        this.title = 'MuchBetter';
      } else if (this.typeid == 2) {
        this.title = 'ECOW';
      } else if (this.typeid == 3) {
        this.title = 'CashtoCode';
      } else if (this.typeid == 4) {
        this.title = 'Credit Card';
        this.DepositTypeId = 69;
      }

      this.DepositTypeId = params['depositId'];
      this.getDepositInfo();
    });

    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(10), Validators.max(10000)]),
    });
  }
  translator = new TranslatePipe(this._LocalizationService);

  ngOnInit() {
    this.coinbaseDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });
    this.getCustomerOne();
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('CreditCard', true);
    if (this._UserHelper.customerUser.CustomerId !== undefined) {
      this._ApiService
        .getInsicStatus()
        .then(res => {
          this._UserHelper.userInsicStatus = res;
        })
        .catch(err => {
          console.log('deposit-apco, getInsicStatus', err);
          this._UiHelper.errorSnackBar(this.translator.transform('InsicStatusCatchErrorMessage', null), '');
        });
    }
  }

  iframesrc;
  submitCoinbaseData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositApco(this.coinbaseDatas.value.amount, this.typeid).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      const apcoresult = JSON.parse(result);
      if (apcoresult.result == 'success') {
        this.firststep = false;
        //this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(apcoresult.desc);
        this._UiHelper.setLoadingDialog(true);
      } else {
        this._UiHelper.errorSnackBar(apcoresult.desc, '');
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }

  changeAmount(e) {
    this.coinbaseDatas.patchValue({ amount: e });
  }

  paymentpageLoaded() {
    this._UiHelper.setLoadingDialog(false);
  }
  userProfileList;
  getCustomerOne() {
    this._ApiService.getCustomerOne().then(CustomerOne => {
      this.userProfileList = CustomerOne[0];
    });
  }

  getDepositInfo() {
    this._ApiService.getAllDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const depositInfo = result.filter(item => item.DepositTypeId == this.DepositTypeId);

      if (depositInfo == null || depositInfo.length == 0) {
        this.coinbaseDatas = this._FormBuilder.group({
          amount: new UntypedFormControl({ value: '', disabled: true }, [
            Validators.required,
            Validators.maxLength(5),
            Validators.min(this.MinValue),
            Validators.max(this.MaxValue),
          ]),
        });
      } else {
        this.MinValue = depositInfo[0].MinValue;
        this.MaxValue = depositInfo[0].MaxValue;

        if (depositInfo.length > 0) {
          this.coinbaseDatas = this._FormBuilder.group({
            amount: new UntypedFormControl({ value: '', disabled: false }, [
              Validators.required,
              Validators.maxLength(5),
              Validators.min(this.MinValue),
              Validators.max(this.MaxValue),
            ]),
          });
        }
      }
    });
  }
}
